/**
 * Checkout must use a catalog booking-protection product. An empty list is not
 * a CFMR placeholder — callers should no-op instead of inventing a product id.
 */
function getInsuranceBookingProtectionCheckoutProduct(
  products: Array<App.InsuranceProduct>,
): App.InsuranceProduct | undefined {
  return products[0]
}

export default getInsuranceBookingProtectionCheckoutProduct
